export const allFuelTypes = {
    petrol: 'Petrol',
    diesel: 'Diesel',
    internal_lpg_cng: 'CNG', // eslint-disable-line
    electric: 'Electric',
};
